import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'unbrace/components';

type Props = {
  to: string;
} & React.ComponentProps<typeof Button>;

const LinkButton: React.FC<Props> = ({ to, ...props }: Props) => (
  <Link to={to}>
    <Button {...props} />
  </Link>
);

export default LinkButton;
